import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalOverlayRef } from 'src/app/modal/modal-overlay-ref';

@Component({
    selector: 'gl-welcome-pro-popup',
    templateUrl: './welcome-pro-popup.component.html',
    styleUrls: ['./welcome-pro-popup.component.scss'],
    standalone: false
})
export class WelcomeProPopupComponent {
  constructor(private modalRef: ModalOverlayRef, private translate: TranslateService) {
    this.modalRef.backgroundClicked();
  }

  public close() {
    this.modalRef.close();
  }

  public generateInstructionLink() {
    const currentLang = this.translate.currentLang;
    if (currentLang === 'pl') {
      return `https://www.goodloading.com/pl/instrukcja-nowa-wersja/`;
    } else {
      return `https://www.goodloading.com/en/instruction-new-version/`;
    }
    // return `https://www.goodloading.com/${this.translate.currentLang}/${
    //   this.translate.instant('instruction') as string
    // }/`;
  }
}
